import React, { Component } from 'react';
import { Steps, Button, message,Icon, Input ,Row, Col,Select,DatePicker,InputNumber,Card,Radio} from 'antd';
import './App.css';
import MediaQuery from 'react-responsive';
import {ref,storage} from './constants.js';
import {packsel} from './reducers.js';
import {connect} from 'react-redux';
var msg91 = require("msg91")("90746A2rw4qGzWI582708a3", "WDCLIF", "4" );

const Step = Steps.Step;
var Option = Select.Option;
var option = Select.Option;
const {RangePicker } = DatePicker;
const {TextArea} = Input;
const RadioGroup = Radio.Group;

const steps = [{
  title: 'Search',
  desc: 'Description about this',
  content: 'First-content',

}, {
  title: 'Select Rooms',
  desc: 'Description about this',
  content: 'Second-content',

}, {
  title: 'Information',
  desc: 'Description about this',
  content: 'Last-content',

}];

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      direction:'horizontal',
      from:'',
      to:'',
      adults:'',
      child:'',
      name:'',
      email:'',
      mobile:'',
      request:'',
      pay:'Card',
      cost:'',
      title:'',
      date:[],
      done:false,
    };

  }

  componentDidMount(){
    window.scrollTo(0,0);
    const prop = this.props.data;
    this.setState({adults:prop.adult,child:prop.child,
    cost:prop.cost,title:prop.title,date:prop.date,
    from:prop.date[0],to:prop.date[1]
    })
  }

  dateChange(dates,dateStrings){
    this.setState({from:dateStrings[0],to:dateStrings[1]},function(data){
      console.log('sad',this.state.from);
    })
  }
  adultChange(value){
    this.setState({adult:value})
  }
  childChange(value){
    this.setState({child:value})
  }
  onSelect(){
    console.log("helloji");
    var p =this.state.current;
    p++;
    this.setState({current:p})

  }
  nameChange(eve){
    this.setState({name:eve.target.value})
  }
  emailChange(eve){
    this.setState({email:eve.target.value})
  }
  mobileChange(eve){
    this.setState({mobile:eve.target.value})
  }
  reqChange(eve){
    this.setState({request:eve.target.value})
  }

  bookChange(){
    console.log("sd",this.state.title);

    var self = this;
    var data = {
      name:'aksd',
      email:'aksd',
      mobile:'aksd',
      from:'aksd',
      to:'aksd',
      room:'aksd',
    }

    if(this.state.mobile==''||this.state.email==''){
      message.error("Please enter your details")
    }
    else{
      data.name=self.state.name;
      data.email=self.state.email;
      data.mobile=self.state.mobile;
      data.request=self.state.request;
      data.from=self.state.from;
      data.to=self.state.to;
      data.room=self.state.title;

      var mobileNo = self.state.mobile;
      var msg = "45666"
      console.log("jhasjd",mobileNo);

      ref.child('rooms').push().set(data);
      this.setState({done:true})
      /*
      msg91.send(mobileNo, "Thanks for choosing Wayanad Clif. Your transaction ID is "+msg, function(err, response){
          console.log(err);
          console.log(response);
        });
        */

    }



  }


  choice(current){
    var names =['First Name','Last Name','Email','Confirm Email','Mobile','Confirm Mobile'];

    const list=[];

    switch (current) {
      case 0:

        return(

          <div style={{display:'flex',flexDirection:'column',padding:15,justifyContent:'center',alignItems:'center'}}>
            <RangePicker size="large" style={{maxWidth:400}} format="DD-MM-YYYY" onChange={this.dateChange.bind(this)}/>
            <div style={{display:'flex',flexDirection:'row',marginTop:15}}>
              <div style={{textAlign:'center',marginRight:5}}>
                Adults : <InputNumber min={1}  defaultValue={1}  onChange={this.adultChange.bind(this)}/>
              </div>
            <div style={{textAlign:'center',marginLeft:5}} >
              Children : <InputNumber min={0}  defaultValue={0}  onChange={this.childChange.bind(this)}/>
            </div>
            </div>

          </div>


          )
          break;
        case 1:
        let rooms=[];
        for(let i=0;i<3;i++){
          rooms.push(
            <Card title="Super" style={{margin:5}} extra={i==1?<Icon type="close-circle" style={{ fontSize: '16px',color:'red' }} />:<Icon type="check-circle" style={{ fontSize: '16px',color:'green' }} />}>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                <div>
                  Capacity: {i}
                </div>
                <div>
                  Price: Rs.{i+i+i}/night
                </div>
                <div>
                  <Button type="primary" disabled={i==1?true:false} onClick={this.onSelect.bind(this)}>Book now</Button>
                </div>
              </div>
            </Card>
          )
        }
          return(
            <div style={{display:'flex', flexDirection:'column',margin:5}}>
              {rooms}
            </div>
          )
          break;
        case 2:

          return(
            <div></div>
          )


    }
  }
  next() {
    const current = this.state.current + 1;
    this.setState({ current });
  }
  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }
  changeScreen(){
    this.setState({direction:'vertical'})
  }

  render() {
    const { current } = this.state;

    return (
      <div  style={{width:'100%',marginTop:31,background:'#fff',paddingTop:20}}>

        {this.state.done?
          <div style={{textAlign:'center',margin:'auto',marginTop:20}}><h2>Booking Completed!</h2></div>
          :
          <div className="steps-content" style={{textAlign:'center',margin:'10%'}}>
            <div style={{display:'flex', flexDirection:'row',justifyContent:'space-around',margin:5}}>
              <div style={{display:'flex',flexDirection:'column'}}>
                <Input placeholder="Name" size="large" style={{marginTop:5}} onChange={this.nameChange.bind(this)}/>
                <div style={{display:'flex',flexDirection:'row',marginTop:5}}>
                  <Input placeholder="E-mail" size="large" onChange={this.emailChange.bind(this)}/>
                  <Input placeholder="Mobile" size="large" onChange={this.mobileChange.bind(this)}/>
                </div>
                <Input placeholder="Special request if any" size="large" style={{marginTop:5}}onChange={this.reqChange.bind(this)}/>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',margin:5,}}>
                  <RadioGroup style={{display:'flex',flexDirection:'column'}} defaultValue='now'>
                    <Radio value='now'>Pay Now</Radio>
                    <Radio value='later'>Pay Later</Radio>
                  </RadioGroup>
                </div>
              </div>
              <div className="steps-last">
                <div style={{textAlign:'left',padding:10}}>
                    <p>
                      Item: {this.state.title}
                    </p>
                    <p style={{marginTop:10}}>
                      Date: {this.state.date[0]} - {this.state.date[1]}
                    </p>
                    <p style={{marginTop:10}}>
                      Adult: {this.state.adults}
                    </p>
                    <p style={{marginTop:10}}>Children: {this.state.child}</p><br />
                    <p>
                      <h3>Total: ₹{this.state.cost}</h3>
                    </p>
                </div>
              </div>
            </div>
            <Button type="primary" size="large" onClick={this.bookChange.bind(this)}>Book Now</Button>
          </div>
        }


      </div>
    );
  }
}


const mapStateToProps = ({packsel}) => ({
    data: packsel.data
});
export default connect(mapStateToProps,null)(Details);



// WEBPACK FOOTER //
// ./src/Details.js